<div class="row grid-row">
    <div class="col-md-1 col-sm-1 grid-column" hznTestId="transaction-report-row-date">{{item.transactionDate | bcDate: 'YYYY-MM-DD'}} </div>
    <div class="col-md-1 col-sm-1 grid-column" hznTestId="transaction-report-row-type">{{item.transactionType}} </div>
    <div class="col-md-1 col-sm-1 grid-column">{{item.transactionId}}</div>
    <div class="col-md-2 col-sm-2 grid-column">{{item.totalAmount | amount }}</div>
    <div class="col-md-1 col-sm-1 grid-column">{{item.originalPurchaseNumber }}  </div>
    <div class="col-md-3 col-sm-3 grid-column">{{item.originalPurchaseMemberName}}</div>
    <div class="col-md-2 col-sm-2 grid-column">{{item.originalPurchaseMemberId }}</div>
</div>